import React, { Component } from "react";
import CartDrawerV2 from "../components/CartDrawerV2";
import ContextSheet from "../components/ContextSheet";

export class CartDrawerRoute extends Component {
  state = {
    contextOpen: this.props.location?.state?.openOrderOptions === true,
    contextSheetDraft:
      this.props.location?.state?.contextSheetDraft || null,
  };

  componentDidMount() {
    if (!this.props.location?.state?.openOrderOptions && !this.props.backgroundLocation) return;
    // CartDrawerV2 may already have added its same-page Back entry. Preserve
    // that latest state, and persist the background for a direct cart refresh.
    const location = this.props.history.location || this.props.location;
    this.props.history.replace({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: {
        ...(location.state || {}),
        cartBackground: this.props.backgroundLocation,
        openOrderOptions: false,
        contextSheetDraft: undefined,
      },
    });
  }

  close = () => {
    // The drawer consumes its own Back entry before invoking this callback.
    // A directly opened /cart has no trustworthy previous storefront page.
    this.props.history.replace(this.props.backgroundLocation || "/");
  };

  render() {
    return (
      <>
        <CartDrawerV2
          historyScope="route"
          open={!this.state.contextOpen}
          onChangeContext={() => this.setState({ contextOpen: true })}
          onCheckout={() => this.props.history.push("/checkout")}
          onEditExtras={() =>
            this.props.history.push({
              pathname: "/checkout",
              state: { checkoutV2Step: "extras" },
            })
          }
          onContinueShopping={this.close}
          onClose={this.close}
        />
        <ContextSheet
          history={this.props.history}
          initialDraft={this.state.contextSheetDraft}
          location={this.props.location}
          open={this.state.contextOpen}
          onApplied={() =>
            this.setState({ contextOpen: false, contextSheetDraft: null })
          }
          onClose={() =>
            this.setState({ contextOpen: false, contextSheetDraft: null })
          }
        />
      </>
    );
  }
}

export default CartDrawerRoute;
